import React, {Fragment, useState} from 'react';
import {doTrack} from '../../utils/utils';
import {loginWithDevise, verifySubdomain} from '../../utils/api.utils';
import _ from 'lodash';

export const LoginWithDomain = () => {

  const [subdomain, setSubdomainInState] = useState('');
  const [notFound, setNotFound] = useState(false);
  const [subdomainVerified, setSubdomainVerified] = useState(false);

  const [userName, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const setSubdomain = (sub) => {
    if (notFound) {
      setNotFound(false);
    }
    setSubdomainInState(sub);
  };

  useState(() => {
    doTrack('Login from qube.work');
  }, []);

  const login = () => {
    // make the magic happen and login using devise
    loginWithDevise(userName, password)
      .then(() => {
        window.location.href = '//' + subdomain + '.' + window.location.host;
      })
      .catch((ex) => console.log(ex));
  }

  const loginToWorkspace = () => {

    verifySubdomain(subdomain).then(response => {
      if (_.get(response, 'data.exists')) {
        // redirect to subdomain
        doTrack('Successful domain lookup - redirecting', { subdomain });
        // if (_.get(response, 'data.lite')) {
        //     setSubdomainVerified(true);
        //   window.location.href = '//' + subdomain + '.' + window.location.host;
        // } else {
        window.location.href = '//' + subdomain + '.' + window.location.host;
        // }
      } else {
        doTrack('Domain not found', { subdomain });
        setNotFound(true);
      }
    }).catch((e) => {
      doTrack('Domain not found', { subdomain });
      setNotFound(true);
      console.log(JSON.stringify(e));
    });
  };

  const renderDomainForm = () => (
    <div className={'loginContainer flexRowContainer flexAlignCenter positionRelative'}>
      <div className={'mb20'}>
        <h2>Login to your workspace</h2>
      </div>
      <div className={'mb10'}>Enter your qube subdomain.</div>

      <div className={'flexAlignCenter mb10'}>
        <input className={'ml2 mr2 p5 form-control-inline width-300'}
          onChange={(e) => setSubdomain(e.target.value)}
          value={subdomain}
          autoFocus
          placeholder={'your-qube-workspace'} />.qube.work
      </div>

      {notFound &&
      <div className={'text-danger mb20'}><b>No workspace for subdomain "{subdomain}" found. Please try
        again.</b></div>}
      <div className={'mb50'}>
        <input type="button" className="btn setupBtn"
          value="Continue"
          onClick={loginToWorkspace} />
      </div>

      <div className={'setupHelp'}>Need help? <a href={'mailto:qube@seeq.com'}>Contact us</a>
      </div>
    </div>
  );

  const renderLoginForm = () => {
    return (
      <div className={'loginContainer flexRowContainer flexAlignCenter positionRelative'}>
        <div className={'mb20'}>
          <h2>Login to your workspace</h2>
        </div>


        <div className={'flexAlignCenter mb10'}>
          <input className={'ml2 mr2 p5 form-control-inline width-300'}
            onChange={(e) => setUsername(e.target.value)}
            value={userName}
            autoFocus
            placeholder={'Email'} />
        </div>
        <div className={'flexAlignCenter mb10'}>
          <input className={'ml2 mr2 p5 form-control-inline width-300'}
            onChange={(e) => setPassword(e.target.value)}
            value={password}
            type="password"
            autoFocus
            placeholder={'Password'} />
        </div>

        <div className={'mb50'}>
          <input type="button" className="btn setupBtn"
            value="Login"
            onClick={login} />
        </div>

        <div className={'setupHelp'}>Need help? <a href={'mailto:qube@seeq.com'}>Contact us</a>
        </div>
      </div>
    )
  }

  return (
    <Fragment>
      <div className="logoCorner" />
      <div className="height-maximum flexRowContainer flexCenter setup">
        {subdomainVerified ? renderLoginForm() : renderDomainForm()}
      </div>
    </Fragment>
  );
};
export default LoginWithDomain;
